// Web-based scroll helper utilities.
export function scrollTo({ elementID, behavior = "smooth" as ScrollBehavior, block = "center" as ScrollLogicalPosition }) {
    const element = document.getElementById(elementID);
    if (element !== null) {
        element.scrollIntoView({ behavior: behavior, block: block });
    }
}